import { useState } from "react";
import type { FormEvent } from "react";
import { login } from "../lib/api";
import { formatMonthLabel, formatStatusLabel } from "../lib/format";
import type { PublicConfig } from "../lib/types";

type Props = {
  config: PublicConfig | null;
  onLoggedIn: () => void | Promise<void>;
};

export default function LoginScreen({ config, onLoggedIn }: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (!username.trim() || !password.trim()) {
      setError("IDとパスワードを入力してください");
      return;
    }
    setSubmitting(true);
    const res = await login(username.trim(), password);
    setSubmitting(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    await onLoggedIn();
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1 className="login-title">添削者評価ポータル</h1>
        <p className="login-subtitle">manual-portalと同じID・パスワードでログインできます</p>

        {config && (
          <div
            className={`config-banner ${
              config.status === "closed" ? "config-banner--closed" : "config-banner--open"
            }`}
          >
            {formatMonthLabel(config.activeMonth)} {formatStatusLabel(config.status)} 締切:{" "}
            {config.deadline}
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-field">
            <span>ID</span>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </label>
          <label className="login-field">
            <span>パスワード</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="btn btn--primary" disabled={submitting}>
            {submitting ? "ログイン中..." : "ログイン"}
          </button>
        </form>
      </div>
    </div>
  );
}
